export const validate = {
    data() {
        return {
            mixin_submitBtnState: false,
            mixin_submitBtnStateTimeout: 0
        }
    },
    watch: {
        formData: {
            handler(newName, oldName) {
                clearTimeout(this.mixin_submitBtnStateTimeout)
                this.mixin_submitBtnStateTimeout = setTimeout(() => {
                    this.mixin_handleWatchSubmitState(this.formData)
                }, 200)
            },
            deep: true
        }
    },
    methods: {
        // 侦测formData 中是否输入东西，只要有东西按钮就显示可以提交的颜色
        mixin_handleWatchSubmitState(formData) {
            let filters = Object.keys(formData).filter(key => {
                return (formData[key] != "" && formData[key] != null)
            })
            console.log(filters.length)
            this.mixin_submitBtnState = filters.length > 0;
        },
    },
}